import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "sun-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor" },
        React.createElement("circle", { cx: 8.5, cy: 8.5, r: 3, fill: "currentColor", fillOpacity: 0.2 }),
        React.createElement("path", { strokeLinecap: "round", d: "M8.5 2v1.5m0 10V15M15 8.5h-1.5m-10 0H2m11.096-4.596-1.06 1.06m-7.072 7.072-1.06 1.06m9.192 0-1.06-1.06M4.965 4.964l-1.061-1.06" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
